import { ComponentInjector } from '@atypon/ui-utils';
import PublicationContent, {
    GetFTRElements,
    GetFTRSelectors,
    GetFTRClassList,
    GetFTRTexts,
} from '../../publication-content/ts';

class Texts extends GetFTRTexts {}

class ClassList extends GetFTRClassList {}

class Selectors extends GetFTRSelectors {}

class Elements extends GetFTRElements {}

interface AxelPublicationContent {
    get elements(): Elements;
    get texts(): Texts;
    get classList(): ClassList;
    get selectors(): any;
}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class AxelPublicationContent extends PublicationContent {}

export default AxelPublicationContent;
export {
    Elements as AxelGetFTRElements,
    Selectors as AxelGetFTRSelectors,
    ClassList as AxelGetFTRClassList,
    Texts as AxelGetFTRTexts,
};
